import { Switch } from '@chronosphereio/chrono-ui';
import { HeatmapLegendOptions, HeatmapLegendPosition } from '@/core';
import { OptionsEditorControl, OptionsEditorGroup, SettingsAutocomplete } from '@/plugin-editor-components';

const POSITION_OPTIONS: Array<{ id: HeatmapLegendPosition; label: string }> = [
  { id: 'Bottom', label: 'Bottom' },
  { id: 'Right', label: 'Right' },
];

export interface LegendOptionsEditorProps {
  value: HeatmapLegendOptions;
  onChange: (legend: HeatmapLegendOptions) => void;
}

export function LegendOptionsEditor({ value, onChange }: LegendOptionsEditorProps) {
  return (
    <OptionsEditorGroup title="Legend">
      <OptionsEditorControl
        label="Show"
        control={
          <Switch checked={value.show ?? false} onChange={(e) => onChange({ ...value, show: e.target.checked })} />
        }
      />
      <OptionsEditorControl
        label="Position"
        control={
          <SettingsAutocomplete
            value={POSITION_OPTIONS.find((o) => o.id === value.position) ?? POSITION_OPTIONS[0]}
            options={POSITION_OPTIONS}
            onChange={(_, newValue) => onChange({ ...value, position: newValue.id })}
            disableClearable
            disabled={!value.show}
          />
        }
      />
    </OptionsEditorGroup>
  );
}
